import { Layout } from 'antd';
import {
  Brands,
} from 'containers/layout/header';
import { Partners, Menu } from 'app/layout/components/header';
import SystemConversions from 'app/layout/components/header/SystemConversions';
import { useConnection } from 'hooks';
import { useLayout } from 'contexts/LayoutContext';
import Languages from 'app/layout/components/header/Languages';
import ThemeColorsMode from 'app/layout/components/header/ThemeColorsMode';
import TimeZones from 'app/layout/components/header/TimeZones';
import DateTime from 'app/layout/components/header/DateTime';
import { getSidebarSizes } from 'utils/styledHelpers';
import Logo from 'app/layout/components/header/Logo';
import QuickSearch from 'app/quickSearch/components/QuickSearch';
import { StyledHeader, StyledListFirstItemHeader, StyledList } from 'app/layout/components/Layout.styled';

const sidebarSizes = getSidebarSizes();

export interface HeaderProps {
  isSearch?: boolean,
  collapsedWidth?: string,
  width?: string,
}

const Header = ({
  isSearch = true, collapsedWidth = sidebarSizes.collapsedWidth, width = sidebarSizes.width,
}:HeaderProps) => {
  const {
    partnerSettings, brandSettings, showConversion, timeZoneSettings,
  } = useLayout();

  useConnection();

  return (
    <StyledHeader>
      <Layout.Header id="layoutHeader">
        <Logo collapsedWidth={collapsedWidth} width={width} />
        <StyledList>
          <StyledListFirstItemHeader>
            <DateTime />
            <TimeZones timeZoneSettings={timeZoneSettings} />
            {(partnerSettings?.editMode || partnerSettings?.viewMode) && <Partners partnerSettings={partnerSettings} />}
            {(brandSettings?.editMode || brandSettings?.viewMode) && <Brands brandSettings={brandSettings} />}
            {showConversion && <SystemConversions showConversion={showConversion} />}
          </StyledListFirstItemHeader>
          {isSearch && <QuickSearch />}
          <Languages />
          <ThemeColorsMode />
          <Menu />
        </StyledList>
      </Layout.Header>
    </StyledHeader>
  );
};

export default Header;
